// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentFormSkeleton-paymentSkeletonBox-of9GF {
    padding: 24px;
    border-radius: var(--radius-3);
    background-color: var(--background-primary);
}


.PaymentFormSkeleton-paymentSkeletonTitle-z7_3M {
    max-width: 163px;
    height: 30px;
    background: var(--skeleton-secondary-bg);
    margin-bottom: 18px;
    border-radius: var(--radius-5);
}


.PaymentFormSkeleton-paymentSkeletonCard-VG_ey {
    background-color: var(--background-secondary);
    padding: 18px;
    border-radius: var(--radius-3);
}


.PaymentFormSkeleton-paymentSkeletonCardTopFlex-jWouG {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 10px;
    color: var(--primary-foreground);
}


.PaymentFormSkeleton-paymentSkeletonCardDivider-yXM5H {
    border-bottom: 1px solid var(--primary-border);
    padding-bottom: 12px;
    margin-bottom: 12px;
}


.PaymentFormSkeleton-paymentSkeletonCardLabel-uhAoB,
.PaymentFormSkeleton-paymentSkeletonCardLink-tUwlO {
    height: 26px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}


.PaymentFormSkeleton-paymentSkeletonCardLabel-uhAoB {
    max-width: 177px;
}


.PaymentFormSkeleton-paymentSkeletonCardLink-tUwlO {
    max-width: 86px;
}


.PaymentFormSkeleton-paymentSkeletonCardRadioBtn-JZdml {
    max-width: 24px;
    height: 24px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}


.PaymentFormSkeleton-paymentSkeltonCardBox-t4IOm {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    grid-gap: 24px;
}


@media (max-width: 767px) {
    .PaymentFormSkeleton-paymentSkeletonCard-VG_ey {
        margin-bottom: 24px;
    }

    .PaymentFormSkeleton-paymentSkeltonCardBox-t4IOm {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/PaymentFormSkeleton/PaymentFormSkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,8BAA8B;AAClC;;;AAEA;IACI,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;AAClC;;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;AACpC;;;AAEA;IACI,8CAA8C;IAC9C,oBAAoB;IACpB,mBAAmB;AACvB;;;AAEA;;IAEI,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;;AAEA;IACI,gBAAgB;AACpB;;;AAEA;IACI,eAAe;AACnB;;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;AAClB;;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".paymentSkeletonBox {\n    padding: 24px;\n    border-radius: var(--radius-3);\n    background-color: var(--background-primary);\n}\n\n\n.paymentSkeletonTitle {\n    max-width: 163px;\n    height: 30px;\n    background: var(--skeleton-secondary-bg);\n    margin-bottom: 18px;\n    border-radius: var(--radius-5);\n}\n\n.paymentSkeletonCard {\n    background-color: var(--background-secondary);\n    padding: 18px;\n    border-radius: var(--radius-3);\n}\n\n.paymentSkeletonCardTopFlex {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    color: var(--primary-foreground);\n}\n\n.paymentSkeletonCardDivider {\n    border-bottom: 1px solid var(--primary-border);\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n}\n\n.paymentSkeletonCardLabel,\n.paymentSkeletonCardLink {\n    height: 26px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.paymentSkeletonCardLabel {\n    max-width: 177px;\n}\n\n.paymentSkeletonCardLink {\n    max-width: 86px;\n}\n\n.paymentSkeletonCardRadioBtn {\n    max-width: 24px;\n    height: 24px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.paymentSkeltonCardBox {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    grid-gap: 24px;\n}\n\n@media (max-width: 767px) {\n    .paymentSkeletonCard {\n        margin-bottom: 24px;\n    }\n\n    .paymentSkeltonCardBox {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentSkeletonBox": `PaymentFormSkeleton-paymentSkeletonBox-of9GF`,
	"paymentSkeletonTitle": `PaymentFormSkeleton-paymentSkeletonTitle-z7_3M`,
	"paymentSkeletonCard": `PaymentFormSkeleton-paymentSkeletonCard-VG_ey`,
	"paymentSkeletonCardTopFlex": `PaymentFormSkeleton-paymentSkeletonCardTopFlex-jWouG`,
	"paymentSkeletonCardDivider": `PaymentFormSkeleton-paymentSkeletonCardDivider-yXM5H`,
	"paymentSkeletonCardLabel": `PaymentFormSkeleton-paymentSkeletonCardLabel-uhAoB`,
	"paymentSkeletonCardLink": `PaymentFormSkeleton-paymentSkeletonCardLink-tUwlO`,
	"paymentSkeletonCardRadioBtn": `PaymentFormSkeleton-paymentSkeletonCardRadioBtn-JZdml`,
	"paymentSkeltonCardBox": `PaymentFormSkeleton-paymentSkeltonCardBox-t4IOm`
};
module.exports = ___CSS_LOADER_EXPORT___;
